import script from "./CategoryTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTableRow.vue?vue&type=script&setup=true&lang=js"

import "./CategoryTableRow.vue?vue&type=style&index=0&id=823d6e46&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-823d6e46"]])

export default __exports__